import EnvFile from "./assets/env-prod.json";

// Set public path for asset loading (must run before main bundle)
// eslint-disable-next-line no-undef
__webpack_public_path__ = "https://ze2-static.mlb.com/";

window.MLBBest = {
  envVariables: EnvFile,
};
